import React from 'react';
import { Modal } from '@tvg/fuse/modal';
import { Typography } from '@tvg/fuse/typography';
import Button from 'components/Button/Button';
import { DigitalDownloadDialogProps } from './DigitalDownloadDialogProps';
import styles from './DigitalDownloadDialog.module.css';

function DigitalDownloadDialog(props: DigitalDownloadDialogProps) {
  const { open, onClose, onClick } = props;

  return (
    <Modal
      name="digital_download_dialog"
      open={open}
      onClose={onClose}
      title="Cancellation of Download Codes"
      titleTag="h2"
      dataTestId="digital_download_dialog"
      srLabelCloseButton="Close Cancellation of Download Codes Dialog"
      zIndex="20"
    >
      <Typography type="paragraph" size="1" tag="p">
        Download codes that are available for immediate supply are non-cancellable. By clicking “Continue with purchase”
        you are requesting the immediate supply of the download code and you will therefore lose your legal right to
        cancel this order under distance selling law. Please note that this product is also excluded from our 28 Day
        Approval Guarantee.
      </Typography>

      <Typography type="paragraph" size="1" tag="p">
        Pre-orders of download codes can be cancelled at any time before the code is sent to you - just let us know if
        you wish to cancel
      </Typography>

      <Button
        className={styles.continueButton}
        id="primaryContinueWithPurchase"
        onClick={onClick}
        data-testid="continue_with_purchase__button"
      >
        Continue with purchase
      </Button>
    </Modal>
  );
}

export default DigitalDownloadDialog;
